import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PageHeader } from '@/components/app/PageHeader';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Bell, CheckCircle2 } from 'lucide-react';
import { fmtDate } from '@/lib/format';
import { toast } from 'sonner';

export default function TenantNotices() {
  const [items, setItems] = useState([]);
  const me = JSON.parse(localStorage.getItem('pmcrm_user') || '{}');
  const load = () => api.get('/notices').then(r => setItems(r.data));
  useEffect(() => { load(); }, []);
  const ack = async (id) => { await api.post(`/notices/${id}/acknowledge`); toast.success('Acknowledged'); load(); };
  return (
    <div>
      <PageHeader title="Notices" subtitle="Updates and announcements" />
      <div className="space-y-3">
        {items.map((n) => {
          const acked = n.acknowledged_by?.includes(me.id);
          return (
            <Card key={n.id} className={`p-4 card-hover ${!acked ? 'border-l-2 border-l-[hsl(var(--role-accent))] bg-[hsl(var(--role-accent)/0.04)]' : ''}`}>
              <div className="flex items-start gap-3">
                <div className="h-9 w-9 rounded-lg grid place-items-center bg-[hsl(var(--role-accent)/0.12)] text-[hsl(var(--role-accent))]"><Bell className="h-4 w-4" /></div>
                <div className="flex-1">
                  <div className="flex items-center justify-between gap-2">
                    <div className="font-semibold">{n.title}</div>
                    <div className="text-xs text-muted-foreground">{fmtDate(n.created_at)}</div>
                  </div>
                  <div className="text-xs text-muted-foreground capitalize">{n.category}</div>
                  <div className="text-sm mt-2 whitespace-pre-line">{n.body}</div>
                  <div className="mt-3">{acked ? <span className="text-xs text-[hsl(152_60%_28%)] inline-flex items-center gap-1"><CheckCircle2 className="h-3.5 w-3.5" /> Acknowledged</span> : <Button size="sm" variant="outline" onClick={() => ack(n.id)} data-testid={`ack-notice-${n.id}`}>Mark as read</Button>}</div>
                </div>
              </div>
            </Card>
          );
        })}
        {!items.length && <Card className="p-10 text-center text-muted-foreground">No notices.</Card>}
      </div>
    </div>
  );
}
